<template>
    <div id="budget_alerts" class="container-fluid">
        <router-link :to="{ path: '/budget/alerts/create' }" class="btn btn-secondary main-button pull-right">Add New Alert</router-link>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="actions" slot-scope="props" class="text-right">
                <router-link :to="{ path: `/budget/alerts/${props.row.id}/edit` }" class="btn btn-info reverse">Edit</router-link>
                <button @click="remove(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                tableData: [],
                columns: ['name', 'actions'],
                options: {
                    headings: {
                        name:    'Alert Name',
                        actions: ''
                    },
                    sortable: ['name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} alerts|{count} alerts|One alert',
                        filter: '',
                        filterPlaceholder: 'Search alerts...',
                        noResults: 'No matching alerts'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/budget/alerts')
                ])
                .then(axios.spread((alerts) => {
                    this.tableData = alerts.data;
                }));
            },

            remove(id) {
                this.confirmation(this.messages.WARNING_BUDGET_ALERT_DELETE, () => {
                    axios.delete(`/api/budget/alerts/${id}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: this.messages.BUDGET_ALERT_DELETED
                        });

                        this.fetchServerData();
                    });
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
